import { isBlankNode, isGraphPointer } from 'is-graph-pointer';
import { sh } from '@tpluscode/rdf-ns-builders';
import { toAlgebra } from 'clownface-shacl-path';
import { getOne, getOneOrZero } from './util.js';
import NodeExpressionBase from './NodeExpression.js';
export class PathExpression extends NodeExpressionBase {
    static match(pointer) {
        return isBlankNode(pointer) && isGraphPointer(pointer.out(sh.path));
    }
    static fromPointer(pointer, fromNode) {
        const path = getOne(pointer, sh.path);
        const nodes = getOneOrZero(pointer, sh.nodes);
        if (nodes) {
            return new PathExpression(pointer.term, toAlgebra(path), fromNode.nodeExpression(nodes));
        }
        return new PathExpression(pointer.term, toAlgebra(path));
    }
    get requiresFullContext() {
        var _a, _b;
        return (_b = (_a = this.nodes) === null || _a === void 0 ? void 0 : _a.requiresFullContext) !== null && _b !== void 0 ? _b : false;
    }
    get rootIsFocusNode() {
        return false;
    }
    constructor(term, path, nodes) {
        super();
        this.term = term;
        this.path = path;
        this.nodes = nodes;
    }
    _buildPatterns({ subject, object, variable, rootPatterns }, builder) {
        if (this.nodes) {
            const inner = builder.build(this.nodes, { subject, variable, rootPatterns });
            const joined = inner.object;
            return [
                ...inner.patterns,
                {
                    type: 'bgp',
                    triples: [{
                            subject: joined,
                            predicate: this.path,
                            object,
                        }],
                },
            ];
        }
        return {
            type: 'bgp',
            triples: [{
                    subject,
                    predicate: this.path,
                    object,
                }],
        };
    }
}
